import emojiRegex from 'emoji-regex';
import { getEmojiDataFromNative, Emoji } from 'emoji-mart';
// @ts-ignore
import dataApple from 'emoji-mart/data/apple.json';

import {Chat, ChatKind} from '@common/react/objects/Chat';
import {getUserName} from '@common/react/utils/utils';

import {BaseUserWithAvatar} from '@common/react/objects/BaseUser';
import {linkRegex, regularLink} from '@common/react/components/UI/LinkPreview/LinkPreview';

const regex = emojiRegex();

export const getChatMessageMarkup = (text: string) => {
	const hasText = text.replace(regex, '').length > 0;
	return text.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/\r\n|\r|\n/gi, '<br/>')
		.replace(regex, (emoji) => {
			const emojiData = getEmojiDataFromNative(emoji, 'apple', dataApple);
			return `<span class="${
				hasText ? 'emoji-with-text' : 'emoji-icon'}" title="${emojiData.name}">
${Emoji({html: true, set: 'apple', emoji: emojiData.id, size: hasText ? 22 : 50})}</span>`;
		});
};

export const getChatName = (chat: Chat, userId: number) => {
	const contacts = chat.contacts.filter((user: BaseUserWithAvatar) => user.id !== userId);

	return chat.kind === ChatKind.Personal
		? getUserName(contacts[0])
		: chat.name
			? chat.name
			: contacts.map((contact: BaseUserWithAvatar, index) => (index > 0 ? ', ' : '') + getUserName(contact));
};

export const transformMentionMessage = (text: string, contacts: BaseUserWithAvatar[], withLink: boolean) => {
	return contacts.reduce<string>((newText, contact) => {
		const name = getUserName(contact);
		const regx = new RegExp(`@${name}`, 'g');

		return newText.replace(
			regx,  
			withLink ? `<a class="chat-component__mention" data-id="${contact.id}">${getUserName(contact)}</a>` : getUserName(contact)
		);
	}, text);
};

const linkReplacer = (text: string) => {
	return regularLink(text);
};

export const transformLinks = (text: string) => {
	const regex = new RegExp(linkRegex);
	return text.replace(regex, linkReplacer);
};